<div id="mySidebar" class="sidebar">
  <div class="breadcrumb-style" *ngIf="isBreadcrumb()">
    <span>{{ hoverMenuesService.breadcrumb }}</span>
  </div>
  <div class="content" [class.content-testing]="this.environment">
    <div class="tab-bar" [class.tab-bar-testing]="this.environment">
      <div
        [ngClass]="{
          'tab-bar-unselected': panelStatus.selectedFilter === constants.viewTypes.None,
          'tab-bar-unselected-testing': panelStatus.selectedFilter === constants.viewTypes.None && this.environment
        }"
      ></div>
      <div
        [ngClass]="{
          'tab-bar-unselected': panelStatus.selectedFilter === constants.viewTypes.ViewLinking,
          'tab-bar-unselected-testing':
            panelStatus.selectedFilter === constants.viewTypes.ViewLinking && this.environment
        }"
      ></div>
    </div>
    <div class="viewSelector" [class.viewSelector-testing]="this.environment">
      <div
        onKeyPress
        onKeyDown
        onKeyUp
        class="view-tab"
        [ngClass]="{ 'view-selected': panelStatus.selectedFilter === constants.viewTypes.None }"
        [ngClass]="{
          'view-selected-testing': panelStatus.selectedFilter === constants.viewTypes.None && this.environment
        }"
        (click)="switchView(constants.viewTypes.None)"
      >
        {{ 'MeshNet.ViewNone' | translate }}
      </div>
      <div
        onKeyPress
        onKeyDown
        onKeyUp
        class="view-tab right-tab"
        [ngClass]="{ 'view-selected': panelStatus.selectedFilter === constants.viewTypes.ViewLinking }"
        [ngClass]="{
          'view-selected-testing': panelStatus.selectedFilter === constants.viewTypes.ViewLinking && this.environment
        }"
        (click)="switchView(constants.viewTypes.ViewLinking)"
      >
        {{ 'MeshNet.ViewLinking' | translate }}
      </div>
    </div>
    <div class="box">
      <!-- Status level -->
      <div class="status-box">
        <div *ngIf="panelStatus.isViewLinking()">
          <div class="row">
            <div
              [tooltipDeitres]="'MeshNet.ConditionsNeighbors' | translate"
              [tooltipMeshStatus]="true"
              [tooltipCustomLeft]="-6"
              [tooltipCustomTop]="60"
              class="box-column-neigbor"
            >
              <img alt class="img-status-neighbor" [src]="getImageSource('disconnected', 3)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('disconnected', 2)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('disconnected', 1)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('disconnected', 0)" />
              <div class="status-count-one neighbors" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.neighborCountFor('disconnected') }}
              </div>
            </div>
            <div
              [tooltipDeitres]="'MeshNet.ConditionsNeighbors' | translate"
              [tooltipMeshStatus]="true"
              [tooltipCustomLeft]="-16"
              [tooltipCustomTop]="60"
              class="box-column-neigbor"
            >
              <img alt class="img-status-neighbor" [src]="getImageSource('null', 3)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('null', 2)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('null', 1)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('null', 0)" />
              <div class="status-count-one neighbors" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.neighborCountFor('null') }}
              </div>
            </div>
            <div
              [tooltipDeitres]="'MeshNet.ConditionsNeighbors' | translate"
              [tooltipMeshStatus]="true"
              [tooltipCustomLeft]="-16"
              [tooltipCustomTop]="60"
              class="box-column-neigbor"
            >
              <img alt class="img-status-neighbor" [src]="getImageSource('low', 3)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('low', 2)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('low', 1)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('low', 0)" />
              <div class="status-count-one neighbors" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.neighborCountFor('low') }}
              </div>
            </div>
            <div
              [tooltipDeitres]="'MeshNet.ConditionsNeighbors' | translate"
              [tooltipMeshStatus]="true"
              [tooltipCustomLeft]="-16"
              [tooltipCustomTop]="60"
              class="box-column-neigbor"
            >
              <img alt class="img-status-neighbor" [src]="getImageSource('good', 3)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('good', 2)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('good', 1)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('good', 0)" />
              <div class="status-count-one neighbors" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.neighborCountFor('good') }}
              </div>
            </div>
            <div
              [tooltipDeitres]="'MeshNet.ConditionsNeighbors' | translate"
              [tooltipMeshStatus]="true"
              [tooltipCustomLeft]="-16"
              [tooltipCustomTop]="60"
              class="box-column-neigbor"
            >
              <img alt class="img-status-neighbor" [src]="getImageSource('optimum', 3)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('optimum', 2)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('optimum', 1)" />
              <img alt class="img-status-neighbor" [src]="getImageSource('optimum', 0)" />
              <div class="status-count-one neighbors" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.neighborCountFor('optimum') }}
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!panelStatus.isViewLinking()">
          <div class="row">
            <div
              [tooltipDeitres]="conditionTranslation"
              [tooltipSize]="'large'"
              [tooltipCustomLeft]="-6"
              [tooltipCustomTop]="60"
              class="box-column"
            >
              <img alt class="img-status" [src]="getImageSource('null', 3)" />
              <img alt class="img-status" [src]="getImageSource('null', 2)" />
              <img alt class="img-status" [src]="getImageSource('null', 1)" />
              <img alt class="img-status" [src]="getImageSource('null', 0)" />
              <div class="status-count-one" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.rendererStatusControl.null }}
              </div>
            </div>
            <div
              [tooltipDeitres]="conditionTranslation"
              [tooltipSize]="'large'"
              [tooltipCustomLeft]="-6"
              [tooltipCustomTop]="60"
              class="box-column"
            >
              <img alt class="img-status" [src]="getImageSource('low', 3)" />
              <img alt class="img-status" [src]="getImageSource('low', 2)" />
              <img alt class="img-status" [src]="getImageSource('low', 1)" />
              <img alt class="img-status" [src]="getImageSource('low', 0)" />
              <div class="status-count-one" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.rendererStatusControl.low }}
              </div>
            </div>
            <div
              [tooltipDeitres]="conditionTranslation"
              [tooltipSize]="'large'"
              [tooltipCustomLeft]="-6"
              [tooltipCustomTop]="60"
              class="box-column"
            >
              <img alt class="img-status" [src]="getImageSource('good', 3)" />
              <img alt class="img-status" [src]="getImageSource('good', 2)" />
              <img alt class="img-status" [src]="getImageSource('good', 1)" />
              <img alt class="img-status" [src]="getImageSource('good', 0)" />
              <div class="status-count-one" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.rendererStatusControl.good }}
              </div>
            </div>
            <div
              [tooltipDeitres]="conditionTranslation"
              [tooltipSize]="'large'"
              [tooltipCustomLeft]="-6"
              [tooltipCustomTop]="60"
              class="box-column"
            >
              <img alt class="img-status" [src]="getImageSource('optimum', 3)" />
              <img alt class="img-status" [src]="getImageSource('optimum', 2)" />
              <img alt class="img-status" [src]="getImageSource('optimum', 1)" />
              <img alt class="img-status" [src]="getImageSource('optimum', 0)" />
              <div class="status-count-one" [class.status-count-one-testing]="this.environment">
                {{ panelStatus.rendererStatusControl.optimum }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Panel Count -->
      <div class="progress-bar" *ngIf="panelsService.fetchingPanels">
        <mat-progress-bar [value]="getLoadingStatus()"></mat-progress-bar>
        <span [class.loading-percentage]="this.environment">{{ getLoadingStatus() + '%' }}</span>
      </div>
      <div class="count-box" onKeyPress onKeyDown onKeyUp (click)="handleShowLegends()">
        <button mat-button class="count-box-button" [class.count-box-button-testing]="this.environment">
          {{ getTotal() }} {{ 'MeshNet.Devices' | translate }}
          <img
            alt
            class="img-button"
            [src]="showLegends ? 'assets/icons/menues/arrow_up.svg' : 'assets/icons/menues/arrow_down.svg'"
          />
        </button>
      </div>
      <!-- LEGENDS -->
      <div class="legends showLegends" [ngClass]="showLegends ? 'active' : 'inactive'">
        <div class="legends-content">
          <span class="legends-span" [class.legends-span-testing]="this.environment">{{
            'MeshNet.FilterByConnectivity' | translate
          }}</span>
          <div class="connection-type-container">
            <div *ngFor="let g of glossary['ViewConectivity']" matTooltip="{{ 'MeshNet.' + g.type | translate }}">
              <button
                mat-button
                class="button-item"
                [class.button-item-testing]="this.environment"
                [ngClass]="{ 'button-item-selected': conectivityTypeFilter.includes(g.value) }"
                (click)="mapFilter({ value: g.value, type: 'ViewConectivity' })"
              >
                <img alt class="img-glossary" [src]="g.icon" />

                {{ +getTypeCountLegends('ViewConectivity', g) }}
              </button>
            </div>
          </div>
        </div>
        <div class="legends-content">
          <span class="legends-span" [class.legends-span-testing]="this.environment">{{
            'MeshNet.FilterByInstallation' | translate
          }}</span>
          <div class="installation-type-container">
            <div
              *ngFor="let g of glossary['ViewInstallation']"
              matTooltip="{{ 'MeshNet.' + g.type | translate }}"
              class="installation-type-item"
            >
              <button
                type="button"
                class="button-item installation-type-button"
                [class.installation-type-button-testing]="this.environment"
                [ngClass]="{
                  'button-item-selected': installationTypeFilter.includes(g.value)
                }"
                (click)="mapFilter({ value: g.value, type: 'ViewInstallation' })"
                [class.button-item-testing]="this.environment"
              >
                <img alt class="img-glossary-installation" [src]="g.icon" />

                {{ getTypeCountLegends('ViewInstallation', g) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
